// extracted by mini-css-extract-plugin
module.exports = {"slider":"Rates_slider__9tlm3","date":"Rates_date__vhdxX","slide":"Rates_slide__NbOoL"};